"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AreaLoader = void 0;
var React = require("react");
var react_spinners_1 = require("react-spinners");
var _1 = require(".");
var Loader_styles_1 = require("./Loader.styles");
exports.AreaLoader = (function (_a) {
    var Caption = _a.Caption;
    return (React.createElement(Loader_styles_1.AreaLoaderWrapper, null,
        React.createElement(react_spinners_1.BarLoader, { color: _1.LOADER_COLOR }),
        Caption &&
            React.createElement(Loader_styles_1.LoadingCaption, null, Caption)));
});
